import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive, faBurn, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert } from "bootstrap-vue";
import { computed, ref } from "vue";
import { userOwnsHistory } from "@/api";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryMessages',
    props: {
        history: null,
        currentUser: null
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive, faBurn, faTrash);
        const userOverQuota = ref(false);
        const hasMessages = computed(() => {
            return userOverQuota.value || props.history.deleted || props.history.archived;
        });
        const currentUserOwnsHistory = computed(() => {
            return userOwnsHistory(props.currentUser, props.history);
        });
        return { __sfc: true, props, userOverQuota, hasMessages, currentUserOwnsHistory, faArchive, faBurn, faTrash, FontAwesomeIcon, BAlert, localize };
    }
});
